import Rates from './src/Rates';
export default Rates;